import type { CreateWebinarDto } from "@backend/modules/webinar/dto/create-webinar.dto";
import type { UpdateWebinarDto } from "@backend/modules/webinar/dto/update-webinar.dto";
import { WebinarModel } from "@/store/webinar/webinar.model";
import { getBaseUrl } from "@/common/get-base-url";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { computed } from "vue";
import axios from "axios";
import type { WebinarRo } from "@backend/modules/webinar/dto/webinar-ro";

export const useWebinarStore = defineStore("webinarStore", () => {
  async function create(data: CreateWebinarDto): Promise<void> {
    const res = await axios.post(`${getBaseUrl()}/webinar`, data);
    useRepo(WebinarModel).save(res.data);
  }

  async function update(data: UpdateWebinarDto): Promise<void> {
    const res = await axios.patch(`${getBaseUrl()}/webinar`, data);
    useRepo(WebinarModel).save(res.data);
  }

  async function fetchList(): Promise<void> {
    const res = await axios.get(`${getBaseUrl()}/webinar/list`);
    useRepo(WebinarModel).save(res.data);
  }

  async function fetchWebinar(): Promise<WebinarRo> {
    const res = await axios.get(`${getBaseUrl()}/webinar/next`);
    return res.data;
  }

  async function destroy(id: number): Promise<void> {
    await axios.delete(`${getBaseUrl()}/webinar/${id}`);

    useRepo(WebinarModel).destroy(id);
  }

  const webinars = computed(() => {
    return useRepo(WebinarModel).all();
  });

  return {
    webinars,
    destroy,
    create,
    update,
    fetchList,
    fetchWebinar,
  };
});
